import { useEffect, useRef, useState } from 'react'
import {
    faEllipsisVertical,
    faClone,
    faTrash,
    faCancel,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
    Button,
    Dropdown,
    Container,
    Table,
    Modal,
    Form,
    Tab,
} from "react-bootstrap"
import { faEdit } from "@fortawesome/free-regular-svg-icons"
import { Pagination } from "../../../pages/Pagination"
import Tooltip from "@mui/material/Tooltip"
import {
    formatDate,
    formatToINR,
} from "../../../Utils/helpers/commonhelper"
import nodata from "../../../Utils/assets/img/leads_no_data_found.png"
import { TableSkeleton } from "../../../Utils/skeletonLoader/TableSkeleton"
import { AuthorizationCard } from "../../../pages/AuthorizationCard"
import DeleteModal from '../../DeleteModal'
import { useLocation, useNavigate } from 'react-router-dom'
import useLocalStorageState from 'use-local-storage-state'
import { DeleteRequest, GetRequest, PutRequest } from '../../../Utils/hooks/ApiHandler'
import { toast } from 'sonner'
import { SalesOrderDetailsOffcanvas } from '../SalesOrderDetailsOffcanvas'
import { ProgressCircle } from './ProgressCircle'
import { useOutsideClickHandler } from '../../../Utils/hooks/useOutsideClickHandler'

export const SalesListing = ({
    isMyApproval,
    allSalesOrder,
    activeOffset,
    setActiveOffset,
    salesOrderData,
    fetchSalesOrder,
    heading,
    limit,
    setLimit,
    isLoading,
    columns,
    tempFilterData,


}) => {
    const navigate = useNavigate()
    const location = useLocation();
    const mode = location?.state?.mode || "edit";
    const from = location?.state?.from || ""
    const paramId = location?.state?.paramId


    const [customer, setCustomer] = useLocalStorageState("customer")

    const customer_id = customer?.customer_details?.customer_id
    const token = customer?.token?.authorization || ""
    const rf = customer?.token?.authentication || ""
    const extras = { customer, setCustomer, rf, navigate }
    const headers = {
        Authorization: token,
        Authentication: rf,
    }

    // sales permission
    const permission = customer.customer_details?.permission
    const isSalesOrder = permission?.find(c => c.module_name?.toLowerCase()?.split(" ")?.join("_") === "sales_order")
    const salesPermission = permission?.filter(c => c.module_name?.toLowerCase()?.split(" ")?.join("_") === "sales_order")
    const user_type = Number(customer.customer_details?.user_type)
    const salesGrant = {
        isView: user_type !== 1 ? Boolean(Number(isSalesOrder && salesPermission?.find(c => c.feature_name?.toLowerCase()?.split(" ")?.join("_") === "sales_order")?.view)) : true,
        isCreate: user_type !== 1 ? Boolean(Number(isSalesOrder && salesPermission?.find(c => c.feature_name?.toLowerCase()?.split(" ")?.join("_") === "sales_order")?.create)) : true,
        isEdit: user_type !== 1 ? Boolean(Number(isSalesOrder && salesPermission?.find(c => c.feature_name?.toLowerCase()?.split(" ")?.join("_") === "sales_order")?.edit)) : true,
        isDelete: user_type !== 1 ? Boolean(Number(isSalesOrder && salesPermission?.find(c => c.feature_name?.toLowerCase()?.split(" ")?.join("_") === "sales_order")?.delete)) : true,
        isImport: user_type !== 1 ? Boolean(Number(isSalesOrder && salesPermission?.find(c => c.feature_name?.toLowerCase()?.split(" ")?.join("_") === "import")?.is_action)) : true,
        isExport: user_type !== 1 ? Boolean(Number(isSalesOrder && salesPermission?.find(c => c.feature_name?.toLowerCase()?.split(" ")?.join("_") === "export")?.is_action)) : true,
    }
    // state for show detail page
    const [showSalesOrderDetails, setShowSalesOrderDetails] = useState(false)
    const [departmentToDelete, setDepartmentToDelete] = useState(null)
    const [showDeleteModal, setShowDeleteModal] = useState(false)
    const [loading, setLoading] = useState(false)

    // for dropdown of the filter cards being created by the user
    const [filterCategoriesDropdown, setFilterCategoriesDrop] = useState(false)

    const [openRow, setOpenRow] = useState(null)

    const dataToDisplay =
        !tempFilterData ? allSalesOrder : tempFilterData;
    const isFiltered = tempFilterData !== null;

    const pageCount = Math.ceil(
        (isFiltered
            ? (dataToDisplay?.length || 0)
            : (salesOrderData?.total_count || 0)
        ) / limit
    );
    const [showModal, setShowModal] = useState(false)
    const [toCancelQuotation, setToCancelQuotation] = useState()
    const [rejectReason, setRejectReason] = useState("")
    const filterCategoriesDropRef = useRef(null)

    const [editData, setEditData] = useState(null)
    const [isEditOpen, setIsEditOpen] = useState(false)
    const [isClone, setIsClone] = useState(false)

    // custom hook for outside click handler
    useOutsideClickHandler({
        objRef: filterCategoriesDropRef,
        isDropdown: filterCategoriesDropdown,
        setDropdown: setFilterCategoriesDrop
    })

    useEffect(() => {
        if (tempFilterData !== null) {
            setActiveOffset(0)
        }
    }, [tempFilterData])

    useEffect(() => {
        if (from === "detailPage") {
            handleSalesOrderDetails(paramId);
            window.history.replaceState({}, document.title);
        }
    }, [mode, from])

    // Handle page change from react-paginate
    const handlePageChange = (selectedItem) => {
        setActiveOffset(selectedItem.selected)
    }
    // const handleEditClick = async (id) => {
    //     if (!id) return
    //     try {
    //         const res = await GetRequest(
    //             `/sales/fetchDetailsOfSpecificOrder/${id}`,
    //             { headers },
    //             extras
    //         )
    //         if (res.status === "success") {
    //             const editDataToSet = res.data[0]
    //             setEditData(editDataToSet)
    //             setIsEditOpen(true)
    //             setIsClone(false)
    //             // setsalesOrderId(id)
    //         }
    //     } catch (error) {
    //         console.error(error)
    //     }
    // }

    const handleConfirm = async () => {
        setLoading(true)
        try {
            const payload = {
                quotation_id: toCancelQuotation,
                customer_id: customer_id,
                canceletion_reason: rejectReason,
                user_login_id: customer?.customer_details?.id,
            }
            const res = await PutRequest(
                `quotation/cancelQuotation`,
                payload,
                { headers },
                extras
            )

            if (!res || res.status === "fail") {
                return toast.error(res.message || "something went wrong")
            }
            if (res.status === "success") {
                toast.success(res.message)
                setToCancelQuotation()
                setRejectReason("")
                await fetchSalesOrder()
                setShowModal(false)
            }
        } catch (error) {
            console.error(error)
        } finally {
            setShowModal(false)
            setLoading(false)
        }
    }

    const FilterdCols = columns.filter(c => c !== "Invoiced");
    const Columns = !isMyApproval ? columns : FilterdCols;

    const handleCloseModal = () => {
        setShowModal(false)
        setRejectReason("")
        setLoading(false)
    }

    const handleCancelSalesOrder = (saleOrder) => {
        if (!saleOrder) return

        setToCancelQuotation(saleOrder.sales_id)

        setShowModal(true)
    }

    // Trigger delete modal
    const onDelete = (id) => {
        setDepartmentToDelete(id)
        setShowDeleteModal(true)
    }

    const handleSalesOrderDetails = async (id) => {
        if (!id) return
        try {
            const res = await GetRequest(
                `/sales/fetchDetailsOfSpecificOrder/${id}`,
                { headers },
                extras
            )
            if (res.status === "success") {
                const editDataToSet = res.data
                setEditData(editDataToSet[0])
                setShowSalesOrderDetails(true)

                setIsClone(false)
                // setsalesOrderId(id)
            }
        } catch (error) {
            console.error(error)
        }
    }

    // const handleCloneClick = async (id) => {
    //     if (!id) return;
    //     try {
    //         const res = await GetRequest(
    //             `/sales/fetchDetailsOfSpecificOrder/${id}`,
    //             { headers },
    //             extras
    //         );
    //         if (res.status === "success") {
    //             const cloneDataToSet = res.data[0];
    //             setEditData(cloneDataToSet);
    //             // setsalesOrderId(res.data[0].sales_id);
    //             setIsEditOpen(true);
    //             setIsClone(true);
    //         }
    //     } catch (error) {
    //         console.error(error);
    //     }
    // };

    // Confirm delete and call API
    const handleConfirmedDelete = async () => {
        setLoading(true)
        try {
            const item = allSalesOrder.find((d) => d.sales_id === departmentToDelete)

            const res = await DeleteRequest(
                `sales/deleteSalesOrder/${departmentToDelete}/${customer?.customer_details?.id}`,
                { headers },
                { extras }
            )

            if (res?.status === "success") {
                toast.success(res.message)
                await fetchSalesOrder()
                setLoading(false)
            } else if (res.status === "fail") {
                toast.error(res.message)
                setLoading(false)
            }
        } catch (error) {
            setLoading(false)
            console.error("Delete error:", error)
        } finally {
            setLoading(false)
            setShowDeleteModal(false)
            setDepartmentToDelete(null)
        }
    }


    // if no view permission then show authorization card
    if (!salesGrant?.isView) {
        return <AuthorizationCard></AuthorizationCard>
    }

    return (
        <>
            <DeleteModal
                show={showDeleteModal}
                onClose={() => setShowDeleteModal(false)}
                onConfirm={handleConfirmedDelete}
                isLoading={loading}
                message="Are you sure you want to delete this item?"
            />

            <Tab.Container defaultActiveKey="tab-sales">
                <Tab.Content>
                    <Tab.Pane
                        className="p-0 pt-0 pb-3"
                        eventKey="tab-sales"
                        style={{
                            border: "none",
                            animation: "cardEntry 1s ease-out forwards",
                        }}
                    >
                        <Container
                            fluid
                            style={{
                                fontFamily: "'Poppins', sans-serif",
                                height: "calc(100vh - 14rem)",
                                backgroundColor: "white",
                                padding: 0,
                                animation: "cardEntry 1s ease-out forwards",
                            }}
                            className="mt-3 p-0"
                        >
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    height: "100%",
                                    width: "100%",
                                }}
                            >
                                <div
                                    className="listStyleForContact container-table"
                                    style={{
                                        flex: dataToDisplay?.length > 10 ? 1 : "auto",
                                        overflow: "auto",
                                        overflowX: "auto",
                                        width: "100%",
                                        maxHeight: dataToDisplay?.length > 10 ? "100%" : "auto",
                                        scrollbarWidth: "thin"
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.scrollbarColor = "#e0e0e0 white"

                                    }}
                                >
                                    <Table
                                        style={{
                                            width: "100%",
                                            tableLayout: "auto",
                                            backgroundColor: "white",
                                            marginBottom: "0px",
                                            borderCollapse: "separate",
                                            borderSpacing: "0px",
                                        }}
                                    >
                                        <thead style={{ zIndex: 101 }}>
                                            <tr>
                                                <th
                                                    className="text-start  pinned-column last-pinned-column  bulk-selection-cell customize-cell-width"
                                                    style={{
                                                        width: 60,
                                                        minWidth: 60,
                                                        maxWidth: 60,
                                                        left: 0,
                                                    }}
                                                >
                                                    <span>#</span>
                                                </th>
                                                {
                                                    Columns?.map((col, index) => (
                                                        <th key={`header-${index}`} style={{ textAlign: `${col?.toLowerCase() === "status" && "center"}` }}>{col}</th>
                                                    ))
                                                }
                                                {isMyApproval ? (
                                                    ""
                                                ) : (
                                                    <th>
                                                        Action{" "}
                                                        <i
                                                            className="fa-solid fa-sort"
                                                            style={{ fontSize: "0.6rem" }}
                                                        ></i>
                                                    </th>
                                                )}
                                            </tr>
                                        </thead>

                                        <tbody style={{ textAlign: "start" }}>
                                            {isLoading ? (
                                                <TableSkeleton columnCount={columns.length + 2} />
                                            ) : (
                                                <>
                                                    {/* {allSalesOrder !== null && allSalesOrder?.length == 0 ? */}
                                                    {dataToDisplay !== null && dataToDisplay?.length === 0 ?
                                                        (
                                                            <td
                                                                colSpan={columns.length + 2}
                                                                style={{ textAlign: "center", color: "gray" }}
                                                            >
                                                                <div
                                                                    className="d-flex justify-content-center align-items-center"
                                                                    style={{ padding: "2rem" }}
                                                                >
                                                                    <img
                                                                        src={nodata}
                                                                        alt="No data found"
                                                                        style={{ width: "17rem" }}
                                                                    />
                                                                </div>
                                                            </td>
                                                        )
                                                        :
                                                        (
                                                            dataToDisplay?.map((saleOrder, index) => (
                                                                <tr key={saleOrder?.sales_id || index}>
                                                                    <td>{(activeOffset) * limit + (index + 1)}</td>

                                                                    {/* Dynamic cells based on columns order */}
                                                                    {columns?.map((col, cellIndex) => {
                                                                        switch (col) {
                                                                            case "Date":
                                                                                return (
                                                                                    <td key={`cell-${index}-${cellIndex}`}>
                                                                                        {formatDate(saleOrder.sales_order_date)}
                                                                                    </td>
                                                                                );

                                                                            case "Sales Order#":
                                                                                return (
                                                                                    <td
                                                                                        key={`cell-${index}-${cellIndex}`}
                                                                                        style={{ color: "#0099ff", cursor: "pointer" }}
                                                                                        data-bs-target="#saleOrderDetails"
                                                                                        data-bs-toggle="offcanvas"
                                                                                        onClick={() => handleSalesOrderDetails(saleOrder.sales_id)}
                                                                                    >
                                                                                        {saleOrder.sale_no}{" "}
                                                                                        <i className="fa-regular fa-envelope"></i>
                                                                                    </td>
                                                                                );

                                                                            case "Quotation Number":
                                                                                return (
                                                                                    <td key={`cell-${index}-${cellIndex}`} className="sales-td">
                                                                                        {saleOrder.quotation_number ?? "-"}
                                                                                    </td>
                                                                                );

                                                                            case "Customer Name":
                                                                                return (
                                                                                    <td key={`cell-${index}-${cellIndex}`} style={{ width: "3rem" }}>
                                                                                        {saleOrder.contact_full_name}
                                                                                    </td>
                                                                                );

                                                                            case "Status":
                                                                                return (
                                                                                    <td
                                                                                        key={`cell-${index}-${cellIndex}`}
                                                                                        style={{
                                                                                            textTransform: "capitalize",
                                                                                            textAlign: "center",
                                                                                        }}
                                                                                    >
                                                                                        <span style={{
                                                                                            textTransform: "capitalize",
                                                                                            color:
                                                                                                saleOrder.order_status === "pending"
                                                                                                    ? "#a28414"
                                                                                                    : saleOrder.order_status === "draft"
                                                                                                        ? "#1f7a96"
                                                                                                        : saleOrder.order_status === "cancel"
                                                                                                            ? "#9e1920"
                                                                                                            : saleOrder.order_status === "approved"
                                                                                                                ? "#239b11"
                                                                                                                : saleOrder.order_status === "reject"
                                                                                                                    ? "#4f575b"
                                                                                                                    : "#999",
                                                                                            borderRadius: "12px",
                                                                                            padding: "1.5px 6px",
                                                                                            backgroundColor:
                                                                                                saleOrder.order_status === "pending"
                                                                                                    ? "#f9f0ce"
                                                                                                    : saleOrder.order_status === "draft"
                                                                                                        ? "#ceecf5"
                                                                                                        : saleOrder.order_status === "cancel"
                                                                                                            ? "#f8d3d5"
                                                                                                            : saleOrder.order_status === "approved"
                                                                                                                ? "#c0f7b8"
                                                                                                                : saleOrder.order_status === "reject"
                                                                                                                    ? "#d2d6d8"
                                                                                                                    : "",
                                                                                        }}>{saleOrder?.order_status?.toUpperCase() || "-"}</span>

                                                                                    </td>
                                                                                );

                                                                            case "Invoiced":
                                                                                return !isMyApproval && (
                                                                                    <td key={`cell-${index}-${cellIndex}`} style={{ textAlign: "center" }}>
                                                                                        <Tooltip
                                                                                            title={`${saleOrder?.invoiced_percentage?.toFixed(0) || 0}% Completed`}
                                                                                            arrow
                                                                                            placement="right"
                                                                                            componentsProps={{
                                                                                                tooltip: {
                                                                                                    sx: {
                                                                                                        fontSize: "0.7rem",
                                                                                                        backgroundColor: "#7a3a5e",
                                                                                                        color: "white",
                                                                                                    },
                                                                                                },
                                                                                                arrow: {
                                                                                                    sx: {
                                                                                                        color: "#7a3a5e",
                                                                                                    },
                                                                                                },
                                                                                            }}
                                                                                        >
                                                                                            <div
                                                                                                style={{
                                                                                                    cursor: "pointer",
                                                                                                    display: "inline-block",
                                                                                                    maxWidth: "100%",
                                                                                                    overflow: "hidden",
                                                                                                    textOverflow: "ellipsis",
                                                                                                    whiteSpace: "nowrap",
                                                                                                }}
                                                                                            >
                                                                                                <ProgressCircle
                                                                                                    key={`${heading}-${saleOrder.sales_id}`}
                                                                                                    percentage={saleOrder.invoiced_percentage}
                                                                                                />
                                                                                            </div>
                                                                                        </Tooltip>
                                                                                    </td>
                                                                                );


                                                                            case "Amount":
                                                                                return (
                                                                                    <td key={`cell-${index}-${cellIndex}`} style={{ width: "3rem" }}>
                                                                                        {formatToINR(
                                                                                            JSON.parse(saleOrder?.items)?.[0]?.grand_total
                                                                                        ) || 0}
                                                                                    </td>
                                                                                );

                                                                            case "Expected Shipment Date":
                                                                                return (
                                                                                    <td key={`cell-${index}-${cellIndex}`} style={{ width: "3rem", textAlign: "center" }}>
                                                                                        {formatDate(saleOrder?.shipment_date)}
                                                                                    </td>
                                                                                );
                                                                            // case "Order Status":
                                                                            //   return (
                                                                            //     <td key={`cell-${index}-${cellIndex}`}>
                                                                            //       <img
                                                                            //         src={delivered}
                                                                            //         className="me-2"
                                                                            //         alt=""
                                                                            //         style={{ width: 15 }}
                                                                            //       />
                                                                            //       Delivered
                                                                            //     </td>
                                                                            //   );

                                                                            // case "Delivery Method":
                                                                            //   return (
                                                                            //     <td key={`cell-${index}-${cellIndex}`}>
                                                                            //       By Road
                                                                            //     </td>
                                                                            //   );

                                                                            default:
                                                                                return <td key={`cell-${index}-${cellIndex}`}>-</td>;
                                                                        }
                                                                    })}

                                                                    {/* Actions column */}
                                                                    {isMyApproval ? (
                                                                        ""
                                                                    ) : (
                                                                        <td
                                                                            key={`actions-${index}`}
                                                                            className={!isMyApproval ? "" : "lastactionTd"}
                                                                            style={{
                                                                                zIndex: openRow === saleOrder.sales_id ? 11 : "auto",
                                                                                textAlign: "center"
                                                                            }}
                                                                        >
                                                                            <div>
                                                                                <Dropdown
                                                                                    as="div"
                                                                                    className="dropdownsWithoutToggle"
                                                                                    onToggle={(isOpen) =>
                                                                                        setOpenRow(isOpen ? saleOrder.sales_id : null)
                                                                                    }
                                                                                >
                                                                                    <Dropdown.Toggle
                                                                                        as="button"
                                                                                        type="button"
                                                                                        style={{
                                                                                            background: "none",
                                                                                            border: "none",
                                                                                            padding: 0,
                                                                                            margin: 0,
                                                                                            cursor: "pointer",
                                                                                            lineHeight: "1",
                                                                                        }}
                                                                                        className="three-dot-btn"
                                                                                    >
                                                                                        <FontAwesomeIcon icon={faEllipsisVertical} />
                                                                                    </Dropdown.Toggle>
                                                                                    <Dropdown.Menu
                                                                                        align={"end"}
                                                                                        style={{
                                                                                            width: "7rem",
                                                                                            inset: "0px auto auto 0px",
                                                                                            boxShadow: "rgb(215, 215, 215) 0px 0px 15px",
                                                                                            position: "absolute",
                                                                                            marginTop: "-22px",
                                                                                            marginRight: "30px",
                                                                                            minWidth: "3rem",
                                                                                            zIndex: 1000,
                                                                                        }}
                                                                                    >
                                                                                        {saleOrder.order_status === "approved" ? (
                                                                                            ""
                                                                                        ) : (
                                                                                            <>
                                                                                                <Dropdown.Item
                                                                                                    href="#"
                                                                                                    className="d-flex align-items-center"
                                                                                                    onClick={() => {
                                                                                                        if (!salesGrant?.isEdit) {
                                                                                                            toast.warning("You are not authorized for this action!")
                                                                                                            return
                                                                                                        }
                                                                                                        navigate(
                                                                                                            `/editsalesorder/${saleOrder.sales_id}`,
                                                                                                            {
                                                                                                                state: { mode: "edit" },
                                                                                                            }
                                                                                                        )
                                                                                                    }}
                                                                                                >
                                                                                                    <FontAwesomeIcon
                                                                                                        icon={faEdit}
                                                                                                        style={{
                                                                                                            width: "16px",
                                                                                                            height: "16px",
                                                                                                            marginRight: "9px",
                                                                                                            color: "#5e5f60",
                                                                                                        }}
                                                                                                    />
                                                                                                    Edit
                                                                                                </Dropdown.Item>
                                                                                                <Dropdown.Item
                                                                                                    href="#"
                                                                                                    className="d-flex align-items-center"
                                                                                                    onClick={() => {
                                                                                                        if (!salesGrant?.isCreate) {
                                                                                                            toast.warning("You are not authorized for this action!")
                                                                                                            return
                                                                                                        }
                                                                                                        navigate(
                                                                                                            `/editsalesorder/${saleOrder.sales_id}`,
                                                                                                            {
                                                                                                                state: { mode: "clone" },
                                                                                                            }
                                                                                                        )
                                                                                                    }}
                                                                                                >
                                                                                                    <FontAwesomeIcon
                                                                                                        icon={faClone}
                                                                                                        style={{
                                                                                                            width: "16px",
                                                                                                            height: "16px",
                                                                                                            marginRight: "9px",
                                                                                                            color: "#5e5f60",
                                                                                                        }}
                                                                                                    />
                                                                                                    Clone
                                                                                                </Dropdown.Item>
                                                                                            </>
                                                                                        )}
                                                                                        <Dropdown.Item
                                                                                            href="#"
                                                                                            className="d-flex align-items-center"
                                                                                            onClick={() => {
                                                                                                if (!salesGrant?.isDelete) {
                                                                                                    toast.warning("You are not authorized for this action!")
                                                                                                    return
                                                                                                }
                                                                                                saleOrder.order_status === "approved"
                                                                                                    ? handleCancelSalesOrder(saleOrder)
                                                                                                    : onDelete(saleOrder.sales_id)
                                                                                            }}
                                                                                        >
                                                                                            <FontAwesomeIcon
                                                                                                icon={
                                                                                                    saleOrder.order_status === "approved"
                                                                                                        ? faCancel
                                                                                                        : faTrash
                                                                                                }
                                                                                                style={{
                                                                                                    width: "16px",
                                                                                                    height: "16px",
                                                                                                    marginRight: "9px",
                                                                                                    color: "#5e5f60",
                                                                                                }}
                                                                                            />
                                                                                            {saleOrder.order_status === "approved"
                                                                                                ? "Cancel"
                                                                                                : "Delete"}
                                                                                        </Dropdown.Item>
                                                                                    </Dropdown.Menu>
                                                                                </Dropdown>
                                                                            </div>
                                                                        </td>
                                                                    )}
                                                                </tr>
                                                            ))
                                                        )}

                                                    {dataToDisplay?.length > 7 && (
                                                        <tr
                                                            className="no-hover-row"
                                                            style={{
                                                                backgroundColor: "#ffffff",
                                                                marginTop: "0px !important",
                                                                marginBottom: "0px !important",
                                                            }}
                                                        >
                                                            <td colSpan={columns.length + 2}>
                                                                <div style={{ padding: 0 }}>
                                                                    <div
                                                                        className="d-flex justify-content-between align-items-center gap-2 mt-0"
                                                                        style={{
                                                                            padding: "0.5rem 0",
                                                                        }}
                                                                    >
                                                                        <div className="pagination-left">
                                                                            <p
                                                                                className="mb-0"
                                                                                style={{
                                                                                    fontSize: "14px",
                                                                                    paddingRight: "10rem",
                                                                                }}
                                                                            >
                                                                                Showing {activeOffset + 1} of{" "}
                                                                                {pageCount !== 0 ? pageCount : pageCount + 1}
                                                                            </p>
                                                                        </div>
                                                                        <div className="pagination-right d-flex gap-2 align-items-center">
                                                                            <select
                                                                                style={{
                                                                                    minWidth: "78px",
                                                                                    height: "2.3rem",
                                                                                }}
                                                                                onChange={(e) => {
                                                                                    setLimit(Number(e.target.value))
                                                                                    setActiveOffset(0)
                                                                                }}
                                                                                id="limit"
                                                                                className="form-control form-select"
                                                                            >
                                                                                <option value={25}>25</option>
                                                                                <option value={100}>100</option>
                                                                                <option value={200}>200</option>
                                                                                <option value={300}>300</option>
                                                                            </select>
                                                                            <div className="d-flex align-items-center gap-3">
                                                                                <Pagination
                                                                                    offset={activeOffset}
                                                                                    setOffset={setActiveOffset}
                                                                                    handlePageChange={handlePageChange}
                                                                                    pageCount={pageCount}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )}
                                                </>
                                            )}
                                        </tbody>

                                        <style jsx>{`
                          .sales-td {
                            padding: .5rem 5px !important;
                          }
                        `}</style>
                                    </Table>
                                </div>
                                {dataToDisplay?.length <= 7 && (
                                    <div
                                        style={{
                                            padding: "0.5rem 0",
                                            backgroundColor: "white",
                                            borderTop: "1px solid #e0e0e0",
                                            width: "100%",
                                        }}
                                    >
                                        <div className="d-flex justify-content-between align-items-center gap-2">
                                            <div className="pagination-left">
                                                <p className="mb-0" style={{ fontSize: "14px" }}>
                                                    Showing {activeOffset + 1} of{" "}
                                                    {pageCount !== 0 ? pageCount : pageCount + 1}
                                                </p>
                                            </div>
                                            <div className="pagination-right d-flex gap-2 align-items-center">
                                                <select
                                                    style={{ minWidth: "78px", height: "2.3rem" }}
                                                    onChange={(e) => {
                                                        setLimit(Number(e.target.value))
                                                        setActiveOffset(0)
                                                    }}
                                                    id="limit"
                                                    className="form-control form-select"
                                                >
                                                    <option value={25}>25</option>
                                                    <option value={100}>100</option>
                                                    <option value={200}>200</option>
                                                    <option value={300}>300</option>
                                                </select>
                                                <div className="d-flex align-items-center gap-3">
                                                    <Pagination
                                                        offset={activeOffset}
                                                        setOffset={setActiveOffset}
                                                        handlePageChange={handlePageChange}
                                                        pageCount={pageCount}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                            {showModal && (
                                <Modal show={showModal} onHide={handleCloseModal}>
                                    <Modal.Header closeButton>
                                        <Modal.Title>Cancel Sales Order</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <>
                                            <p>Are you sure you want to cancel the sales order?</p>
                                            <Form.Group controlId="rejectReason">
                                                <Form.Label>Reason</Form.Label>
                                                <Form.Control
                                                    as="textarea"
                                                    rows={3}
                                                    value={rejectReason}
                                                    onChange={(e) => setRejectReason(e.target.value)}
                                                />
                                            </Form.Group>
                                        </>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button
                                            className="btn btn-default-outline me-2"
                                            onClick={handleCloseModal}
                                        >
                                            Cancel
                                        </Button>
                                        <Button
                                            className="btn btn-default"
                                            onClick={handleConfirm}
                                            disabled={rejectReason.trim() === ""}
                                        >
                                            {loading ? "submiting.." : "Confirm"}
                                        </Button>
                                    </Modal.Footer>
                                </Modal>
                            )}
                        </Container>
                    </Tab.Pane>
                </Tab.Content>
            </Tab.Container >
            {showSalesOrderDetails && editData && (
                <SalesOrderDetailsOffcanvas
                    isMyApproval={isMyApproval}
                    isEditOpen={isEditOpen}
                    setIsEditOpen={setIsEditOpen}
                    isClone={isClone}
                    fetchSalesOrder={fetchSalesOrder}
                    show={showSalesOrderDetails}
                    setShowSalesOrderDetails={setShowSalesOrderDetails}
                    salesDetails={editData}
                    // handleCloneClick={handleCloneClick}
                    // handleEditClick={handleEditClick}
                    handleClose={() => setShowSalesOrderDetails(false)}
                />
            )
            }
        </>
    )
}
